export const DELAY_PAYMENTS_FLAGS = [
  'delay_payments_v1_pf',
  'delay_payments_v1_pj'
] as const

export const DELAY_PAYMENTS_FILTER_FLAG = 'delay_payments_filter' as const

export const DELAY_PAYMENTS_MODALITY_EXPANSION_BANNER_FLAG =
  'delay_payments_modality_expansion_banner' as const

export const DELAY_PAYMENTS_INVESTMENT_BANNER_FLAG =
  'delay_payments_investment_banner' as const

export const DELAY_PAYMENTS_REPORT_FORMAT_MODAL_FLAG =
  'delay_payments_report_format_modal' as const

export const DELAY_PAYMENTS_HISTORY_TRANSACTION_DETAIL_FLAG =
  'delay_payments_history_transaction_detail' as const

export const delayPaymentsFlags = [
  ...DELAY_PAYMENTS_FLAGS,
  DELAY_PAYMENTS_FILTER_FLAG,
  DELAY_PAYMENTS_MODALITY_EXPANSION_BANNER_FLAG,
  DELAY_PAYMENTS_INVESTMENT_BANNER_FLAG,
  DELAY_PAYMENTS_REPORT_FORMAT_MODAL_FLAG,
  DELAY_PAYMENTS_HISTORY_TRANSACTION_DETAIL_FLAG
] as const
